// extracted by mini-css-extract-plugin
export default {"content":"CardWithOperations_content__+wC+W","blocked":"CardWithOperations_blocked__SHXwa","operations":"CardWithOperations_operations__ZJUin"};